<iframe [src]="safeSrc()" width="100%" height="100%" frameborder="0"></iframe>
